function productOverviewNav() {
  setTimeout(function() {
    var nav = document.querySelector('.product-overview__toc');
    if (nav !== null) {
      var targets = document.querySelectorAll('.product-overview__toc a');
      Array.from(targets).forEach(function (el) {
        el.addEventListener('click', function (e) {
          e.preventDefault();

          var additionalOffset = 0;
          var targetHash = el.getAttribute('href');
          var targetElement;

          if (targetHash === '#section_warnings') {
            targetElement = document.querySelector(targetHash);
          } else {
            var prevSibling = document.querySelector(targetHash)?.previousElementSibling;
            targetElement = prevSibling ? prevSibling : document.querySelector(targetHash);
          }

          if (window.innerWidth <= 992) {
            additionalOffset += 60;
          }

          if (targetElement) {
            var targetOffsetTop =
              targetElement.getBoundingClientRect().top +
              window.scrollY -
              100 - additionalOffset;

            history.replaceState(null, null, targetHash);
            window.scrollTo({
              top: targetOffsetTop,
              behavior: 'smooth'
            });
          } else {
            console.warn('Element with target hash not found:', targetHash);
          }
        });
      });
    }
  }, 100);
}

export { productOverviewNav };
